import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryProvider } from "./lib/query-provider.tsx";
import Landing from "./pages/Landing.tsx";
import Builder from "./pages/Builder.tsx";
import "./index.css";

export function App() {
  return (
    <QueryProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/builder" element={<Builder />} />
        </Routes>
      </BrowserRouter>
    </QueryProvider>
  );
}

export default App;
